export class AsociadoModel {
  nombre1: string = "";
  nombre2?: string = "";
  primerApellido: string = "";
  segundoApellido?: string = "";
  numeroDocumento?: string = "";
  estado?: number;
  email?: string = "";
}


// WEBPACK FOOTER //
// ./src/app/shared/models/datosAsociado.ts